module.exports = __webpack_public_path__ + "img/img_logo_p2ps2.b7a94e0e.svg";